/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpecialRequirement = {
    None: 'NONE',
    TsaDriver: 'TSA_DRIVER',
    TwicDriver: 'TWIC_DRIVER',
    TeamDrivers: 'TEAM_DRIVERS'
} as const;
export type SpecialRequirement = typeof SpecialRequirement[keyof typeof SpecialRequirement];

